import { onBeforeUnmount, watch } from 'vue';
import { ownChannelGeneration } from 'dashboard/store/modules/internalChatMessageHelpers';

export const useInternalChatDrafts = ({
  store,
  accountId,
  channelId,
  parentId,
}) => {
  const pending = new Map();
  let writes = Promise.resolve();
  const enqueue = draft => {
    writes = writes
      .then(() => {
        if (
          accountId.value !== draft.accountId ||
          store.state.internalChat.contextGeneration !== draft.generation ||
          !draft.ownsChannel()
        )
          return undefined;
        const {
          accountId: draftAccount,
          generation,
          ownsChannel,
          ...attributes
        } = draft;
        return store.dispatch('internalChat/saveDraft', attributes);
      })
      .catch(() => {
        /* Preserve the buffer; message send does not depend on autosave success. */
      });
  };
  const flush = () => {
    pending.forEach(({ timer, draft }) => {
      clearTimeout(timer);
      enqueue(draft);
    });
    pending.clear();
    return writes;
  };
  const cancel = () => {
    pending.forEach(({ timer }) => clearTimeout(timer));
    pending.clear();
  };
  const change = (draftParentId, value) => {
    if (!channelId.value) return;
    const key = `${channelId.value}:${draftParentId || 'root'}`;
    clearTimeout(pending.get(key)?.timer);
    const attributes = typeof value === 'string' ? { content: value } : value;
    const draft = {
      accountId: accountId.value,
      generation: store.state.internalChat.contextGeneration,
      ownsChannel: ownChannelGeneration(
        store.state.internalChat,
        channelId.value
      ),
      channelId: channelId.value,
      parentId: draftParentId,
      content: attributes.content,
      contentAttributes: attributes.contentAttributes || {},
    };
    const timer = setTimeout(() => {
      pending.delete(key);
      enqueue(draft);
    }, 500);
    pending.set(key, { timer, draft });
  };
  watch(accountId, cancel, { flush: 'sync' });
  watch([channelId, parentId], flush);
  onBeforeUnmount(cancel);
  return { change, flush, cancel };
};
